export default __webpack_public_path__ + "static/media/7e7ris.5ece883c.gif";